<template>
  <div class="container">
    <div id="chartdiv">
    <timechart v-if="loaded" :chartdata="chartdata" :options="options" :chart-id="myID"/>
    </div>
    <p style="font-size:14px" v-if="filterText!=''">{{filterText}}</p>
    <b-form-checkbox size="sm" v-if="showAdjustYaxis" v-model="adjustYaxis" switch @change="adjustY()" >Adjust Y Axis scale for better visibility. {{YaxisText}}</b-form-checkbox>
  </div>
</template>

<script>
import TimeChart from "./TimeChart.js";
import { API } from "aws-amplify";
import { nextTick } from 'vue';

export default {
  name: "TimeChartContainer",
  components: {
    timechart: TimeChart
  },
  props: ["collection_id", "collection_type", "user", "chart_id", "label", "reflines", "instance_num", "targets", "targetValues", "adjustment", "colorScheme", "filter"],
  data: () => ({
    loaded: false,
    chartdata: null,
    maindata: null,
    adjustYaxis: true,
    showAdjustYaxis: false,
    YaxisTag: {},
    YaxisText: '',
    filterText: "Chart loading...",
    myID: "dave3",
    options: {
      bezierCurve : false,
      elements: {
        line: {
          tension: 0
        }
      },
      scales: {
        xAxes: [
          {
            type: "time",
            time: {
              unit: 'day',
                    displayFormats: {
           'millisecond': 'MMM DD',
           'second': 'MMM DD',
           'minute': 'MMM DD',
           'hour': 'MMM DD',
           'day': 'MMM DD',
           'week': 'MMM DD',
           'month': 'MMM DD',
           'quarter': 'MMM DD',
           'year': 'MMM DD'
                    }
                }
          }
        ],
        yAxes: [{
            ticks: {
            }
        }]
      },
      responsive: true,
      subtitles: [],
      maintainAspectRatio: false,
      annotation: {
        annotations: [
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 220,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: 'Max'
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 180,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '99%'
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 140,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '95%'
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 100,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '90%'
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4.5,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 60,
              content: 'Avg',
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 0,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: 'Median'
            }  
          }

        ]
      }
      
    }
  }),
  async mounted() {
    this.loaded = false;
    // console.log("TimeChartContainer: ",this.chart_id);
    this.myID = this.chart_id;
    if ((this.myID=="PDB_IOMBPS")&&( (this.adjustment!=undefined) && (this.adjustment*1!=0)&&(this.adjustment*1!=1))) {
      this.myID="PDB_IOMBPSADJ";
    }
    if ((this.myID=="PDB_IOPS")&&( (this.adjustment!=undefined) && (this.adjustment*1!=0)&&(this.adjustment*1!=1))) {
      this.myID="PDB_IOPSADJ";
    }
    
    try {
      // console.log("TCC: I am here");
      let sorted = [];
      let total_val = 0;
      let current_val = 0;
      let filterCount = 0;
      
      // console.log("TCC filter",this.filter, ( ((this.filter==undefined)||(this.filter=="NaN")||(this.filter*1==0)) || ((this.filter!=undefined)&&(this.filter*1>0)) ) );
      
      var tries = 2;
      while (tries > 0) {
        var new_collection_id = this.collection_id;
        if (this.instance_num === undefined) {
        } else
        {
          new_collection_id = this.collection_id+'-'+this.instance_num;
        }
        await API.get("dbcsiAPI", `/dbcsi/${new_collection_id}/${this.collection_type}/${this.chart_id}`)
          .then(response => {
            // console.log("TCC: I am here3");
              this.maindata = response.data;
              this.newdata = [[], [], []];
              
              filterCount = 0;

// console.log("TCC: "+this.maindata.length);
              for (var ii = 0; ii < this.maindata.length; ii++) {
                
                if ( ((this.filter==undefined)||(this.filter=="NaN")||(this.filter*1==0)) || ((this.filter!=undefined)&&(this.filter*1>0)&&(this.maindata[ii].y*1<this.filter*1)) ) {
                  //we are not using a filter or we meet the filter
                
                  if (((this.chart_id=="CPUAVGPEAK")||(this.chart_id=="IO_MBS_AVGPEAK")||(this.chart_id=="IOPS_AVGPEAK")||(this.chart_id=="PDB_IOPS")||(this.chart_id=="PDB_CPU_USAGE_PER_S")||(this.chart_id=="PDB_IOMBPS")||(this.chart_id=="cpu_per_s")||(this.chart_id=="cpu_per_s_max")) && 
                          (this.adjustment!=undefined)&&(this.adjustment*1!=0)&&(this.adjustment*1!=1)) {
                    this.newdata[0].push({
                      x: this.maindata[ii].x,
                      y: this.maindata[ii].y/(this.adjustment*1)
                    });
                    current_val=Number(this.maindata[ii].y/(this.adjustment*1));
                    // console.log("adjustment", this.adjustment);
                  } else {  
                    this.newdata[0].push({
                      x: this.maindata[ii].x,
                      y: this.maindata[ii].y
                    });
                    current_val=Number(this.maindata[ii].y);
                  }
               
                  //calculate statistics
                  
                  total_val = total_val + current_val;
                  sorted.push(current_val);
                }  else {
                  filterCount++;
                }
              }

              tries = 0;
            // console.log(this.maindata);
          })
          .catch(error => {
            console.log("TCC Error:", error);
          });
        tries -= 1;
      }

      this.chartdata = {
        datasets: [
          {
            label: this.label,
            data: this.newdata[0],
            borderColor: "#3e95cd",
            backgroundColor: "#3e95cd",
            borderWidth: 2,
            pointRadius: 1,            
            fill: false
          }
        ]
      };
      
      if (filterCount>0) {
        this.filterText = "Note: "+filterCount+" data points (out of "+this.maindata.length+") were filtered from the chart because they were above the expected reasonable value of "+(this.filter*1).toFixed(0) + ".  ";
      } else {
        this.filterText = "";
      }
      
      if (this.colorScheme=="adhoc1") {
        this.chartdata.datasets[0].borderWidth = 1;
      }
      
      if ((this.chart_id=="PDB_IOMBPS")||(this.chart_id=="PDB_CPU_USAGE_PER_S")||(this.chart_id=="PDB_IOPS")||(this.chart_id=="IOPS_AVGPEAK")||(this.chart_id=="IO_MBS_AVGPEAK")) {
        // this.chartdata.datasets[1].borderColor = "brown";
        // this.chartdata.datasets[1].backgroundColor = "tan";
        // 217, 206, 178
        this.chartdata.datasets[0].borderColor = "#ff0000";
        this.chartdata.datasets[0].backgroundColor = "rgba(255, 0,0, 0.25)";
        this.chartdata.datasets[0].fill = true;
        this.chartdata.datasets[0].borderWidth = 1;
      }
      

   if(this.maindata.length==0) {
     // console.log("chartid",this.chart_id, this.maindata.length);
     this.chartdata.datasets[0].label = "No data-- next time, use latest version of DBCSI data collection script" ;
   }
  	
      //calculate statistics
      //sort values
      //calculate median and percentiles
      sorted.sort(function(a, b){return a-b});

      // console.log("chartid",this.chart_id, sorted);
      
      let pctl90 = sorted[Math.min(sorted.length-1, Math.trunc(sorted.length*89.999/100)+1)];
      let pctl95 = sorted[Math.min(sorted.length-1, Math.trunc(sorted.length*95/100)+1)];
      let pctl99 = sorted[Math.min(sorted.length-1, Math.trunc(sorted.length*98.999/100)+1)];
      let pctl50 = sorted[Math.min(sorted.length-1, Math.trunc(sorted.length*50/100)+1)];
      let pctlmax = sorted[sorted.length-1];
      let pctlavg = (total_val/sorted.length);
      
      //console.log (total_val);
      
      //update annotations
      let scale=10;
      this.options.annotation.annotations[5].value = pctl50;
      this.options.annotation.annotations[5].label.content = "Median: "+Math.round(pctl50*scale)/scale;
      this.options.annotation.annotations[4].value = pctlavg;
      this.options.annotation.annotations[4].label.content = "Avg: "+Math.round(pctlavg*scale)/scale;
      this.options.annotation.annotations[3].value = pctl90;
      this.options.annotation.annotations[3].label.content = "90%: "+Math.round(pctl90*scale)/scale;
      this.options.annotation.annotations[2].value = pctl95;
      this.options.annotation.annotations[2].label.content = "95%: "+Math.round(pctl95*scale)/scale;
      this.options.annotation.annotations[1].value = pctl99;
      this.options.annotation.annotations[1].label.content = "99%: "+Math.round(pctl99*scale)/scale;
      this.options.annotation.annotations[0].value = pctlmax;
      this.options.annotation.annotations[0].label.content = "Max: "+Math.round(pctlmax*scale)/scale;
      
      // should we adjust the Y axis ?
      if ( (pctlmax > 20* pctl90)  && this.adjustYaxis) {
        this.options.scales.yAxes[0].ticks.max = Math.round(pctl90*15/10)*10;
        this.YaxisTag = this.options.scales.yAxes[0].ticks;
        this.showAdjustYaxis = true;
        this.YaxisText = "The maximum value in the dataset is "+Math.round(pctlmax*scale)/scale +".";
      }
      
      //done
    
     // console.log(this.reflines);  
     if ((this.reflines==false) || (this.reflines=="false")) {
       //if targets
       if (this.targets == undefined) {
         this.options.annotation = {};
       } else
       {
         let targetArr = this.targets.split(":");
         for (var ii = 0; ii < targetArr.length; ii++) {
           this.options.annotation.annotations[ii].label.content=targetArr[ii];
           this.options.annotation.annotations[ii].value=this.targetValues.split(":")[ii];
           //console.log(this.options.annotation.annotations[ii].label.content,this.options.annotation.annotations[ii].value);
         }
         //fix label offsets
         this.options.annotation.annotations[0].label.xAdjust=0;
         this.options.annotation.annotations[1].label.xAdjust=100;
         this.options.annotation.annotations[2].label.xAdjust=200;
         this.options.annotation.annotations[3].label.xAdjust=300;
         this.options.annotation.annotations[4].label.xAdjust=400;
         this.options.annotation.annotations[5].label.xAdjust=500;

         this.options.annotation.annotations[0].label.yAdjust=5;
         this.options.annotation.annotations[1].label.yAdjust=5;
         this.options.annotation.annotations[2].label.yAdjust=5;

         this.options.annotation.annotations[0].borderDash = [5, 15];
         
         // clear out remaining annotations
         this.options.annotation.annotations.splice(targetArr.length,6-targetArr.length);
         
       }   
     }  
      
      
      this.loaded = true;
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    async adjustY() {
      if (this.adjustYaxis) {
        this.options.scales.yAxes[0].ticks = this.YaxisTag;
      } else {
        this.options.scales.yAxes[0].ticks = {};
      }  
      this.loaded=false;
      await nextTick();
      
      // console.log("adjust:", this.options.scales.yAxes[0].ticks, this.adjustYaxis);
      this.loaded=true;
      
    }
   }
};
</script>